import React from "react";
import { PageHero, SectionHeading } from "../components/Sections";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { EnquiryDialog } from "../components/LeadForm";
import { faqs } from "../mock/data";
import { HelpCircle } from "lucide-react";

export default function FAQs() {
  return (
    <div>
      <PageHero title="Frequently Asked Questions"
        subtitle="Clear answers about how our facilitation platform works, your data and your rights."
        crumbs={[{ label: "FAQs" }]} />
      <section className="section-pad">
        <div className="container-page grid gap-10 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <Accordion type="single" collapsible className="space-y-3">
              {faqs.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="rounded-xl border px-5">
                  <AccordionTrigger className="text-left font-heading text-base font-semibold hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
          <aside>
            <Card className="border p-6 text-center">
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary">
                <HelpCircle className="h-6 w-6" />
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold">Still have questions?</h3>
              <p className="mt-1.5 text-sm text-muted-foreground">Our team is happy to help you understand your options.</p>
              <div className="mt-5">
                <EnquiryDialog trigger={<Button className="w-full">Ask us</Button>} />
              </div>
            </Card>
          </aside>
        </div>
      </section>
    </div>
  );
}
